import { render, staticRenderFns } from "./AddOrUpdatePatientPreviousMedications.vue?vue&type=template&id=50451c9e&"
import script from "./AddOrUpdatePatientPreviousMedications.vue?vue&type=script&lang=js&"
export * from "./AddOrUpdatePatientPreviousMedications.vue?vue&type=script&lang=js&"
import style0 from "./AddOrUpdatePatientPreviousMedications.vue?vue&type=style&index=0&id=50451c9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports